// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"48":"laboratory","353":"contact","417":"setting","857":"report","899":"payment","962":"home","964":"product"}[chunkId] + "." + {"48":"ecb03c4e","353":"b20bc399","417":"6b821d34","857":"bdd5b571","899":"53623755","962":"98efd2f4","964":"071e9edf"}[chunkId] + ".css";
};